import { BOOKING, IMAGES } from "@/lib/site";
import { Reveal } from "./Reveal";
import { SiteButton } from "./SiteButton";

const FinalCTA = () => {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={IMAGES.reset}
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/85" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-transparent to-ink" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8 py-28 md:py-40 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase font-medium text-ember">
            Now open in West Perth
          </p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-cream">
            One hour. Your space. <em className="italic text-ember">Your reset.</em>
          </h2>
          <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-sand max-w-xl mx-auto">
            Launch pricing of A$50 won't last forever. Grab a slot, invite the
            crew, and make recovery the best hour of your week.
          </p>
          <div className="mt-10">
            <SiteButton testid="final-cta-book-button" href={BOOKING.book}>
              Book a private session
            </SiteButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
